<template>
  <el-config-provider :locale="elementLocale">
    <BrowserCheck />

    <router-view />

    <!-- 全局登录弹窗：取消独立登录页后统一从此进入 -->
    <LoginDialog />

    <!-- 拖拽过程中的全局公共临时div -->
    <!-- 全局所有业务场景中凡是涉及到拖拽元素的，都建议使用此div，并将拖拽内容插入到此div中 -->
    <!-- 不要在业务组件内创建拖拽过程中的临时div，因为拖拽div使用fixed定位，而fixed受父、祖级元素的定位影响 -->
    <div id="dragContentCommon" class="drag-content-common"></div>
  </el-config-provider>
</template>

<script lang="ts" setup>
import { computed, watch } from "vue";
import { useRoute } from "vue-router";
import LoginDialog from "@/components/login/LoginDialog.vue";
import { useViewportVideoHotkey } from "@/hooks/useViewportVideoHotkey";
import { elementPlusLocale } from "@/i18n/elementLocale";
import { applyRouteDocumentTitle } from "@/i18n/routeTitle";
import { useI18n } from "@/i18n/useI18n";

useViewportVideoHotkey();

const route = useRoute();
const { locale } = useI18n();

/** Element Plus 组件文案跟随界面语言 */
const elementLocale = computed(() => elementPlusLocale(locale.value));

watch(
  [() => route.path, locale],
  () => {
    applyRouteDocumentTitle(route.path, route.meta.title);
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped>
.drag-content-common {
  display: none;
  // display: flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 50px;
  height: 50px;
  background-color: red;
  pointer-events: none;
  z-index: 10;
}
</style>
